module.exports = __webpack_public_path__ + "static/img/kakaoTalk.b176835.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/images/ico/kakaoTalk.png
// module id = xOqy
// module chunks = 0